import { createTask, updateTask } from '../graphql/mutations';
import APIAmplify from '@/amplify/api';

export const createNewTask = async inputTask => {
    try {
        const res = await APIAmplify.graphql({
            query: createTask,
            variables: {
                input: inputTask
            }
        });

        return res.data.createTask;
    } catch (ex) {
        console.log('exception', ex);
    }
    return null;
};

export const updateTaskById = async inputTask => {
    let infoLineCsv = {
        corporationId: 'corp_bca7cb92-b2a6-4d48-bc84-464dacec35b3',
        projectId: 'project_550268bf-d5b3-46a8-a17f-4c4e9ef432df',
        userId: 'user_9255db04-d3b6-48db-bbb8-cbce95be7cc0',
        formId: 'form_9dfd83fa-c367-4691-81df-ee07d167a527',
        settingCsv: {
        layer: 2,
        fileTypes: 'pdf,tiff,tif,jpeg,jpg,jfif,jfi,jif,bmp,png',
        username: '',
        password: '',
        selectedTypeImportCsv: 1,
        selectedOptionKnowledgeId: 'knowledge_8a7d3af6-ade7-4ad9-a76d-a760e86ad260',
        selectedUniqueField: {},
        selectedUniqueCsv: 'knowledge_8a7d3af6-ade7-4ad9-a76d-a760e86ad260',
        selectedAttachFile: 1
        },
        mappingData: {
        'field_5375144c-188c-4492-8737-e1b13b21aa3a': 'タイトル「【ロイヒつぼ膏】 耳鳴りがするので、頭に貼ってもよいですか。」',
        'field_319dbb54-002c-448e-b48a-1448958d129d': ''
        },
        line: 24839,
        fileName: 'data test.csv',
        uploadKey: 'data test.csv_1714968956954',
        totalLine: 24839,
        sessionId: 'solutiondesk_488f2f8b-cd22-496d-a118-392a5b49cce0',
        firstLineUpload: 24839
    };

    try {
        let res = await APIAmplify.graphql({
            query: updateTask,
            variables: {
                input: {
                    id: 'dd229c8a-792f-4789-8185-00148c071be0',
                    usage: 1,
                    type: 'COMMAND_UPLOAD_CSV',
                    status: 3,
                    createdAt: '2024-05-06T04:32:44.304Z',
                    info: JSON.stringify(infoLineCsv)
                }
            }
        });
        return res.data.updateTask;
    } catch (ex) {
        console.log('updateTask error: ', ex);
        return null;
    }
};
